// extracted by mini-css-extract-plugin
export default {"waitingRoomContainer":"WaitingRoom_waitingRoomContainer__7-mVa","mainContent":"WaitingRoom_mainContent__ziOkp"};